module.exports = function() {
  return new Worker(__webpack_public_path__ + "7603b586899ecdd79bc2.worker.js");
};